var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveCardBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2043.68 1045.55C2105.44 983.796 2105.44 883.127 2043.68 821.377L1172.02 -50.2216C904.291 -317.926 468.52 -317.926 200.794 -50.2216C-66.9314 217.483 -66.9314 653.22 200.794 920.924L801.867 1521.95C865.118 1585.2 949.203 1620 1038.53 1620C1121.99 1620 1200.71 1589.56 1262.34 1534.17L425.105 697.006C424.855 696.881 424.855 696.881 424.855 696.881C354.992 627.023 316.692 534.088 316.567 435.414C316.567 336.49 354.992 243.804 424.855 173.947C569.073 29.7405 803.614 29.7405 947.831 173.947L1819.5 1045.55C1849.56 1075.61 1889.36 1091.95 1931.53 1091.83C1973.95 1091.83 2013.87 1075.36 2043.68 1045.55Z",
    fill: "#007AFF",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCardBackground);
export default __webpack_public_path__ + "static/media/InactiveCardBackground.033f38cfa24ea988aa0b2a62bdc5d166.svg";
export { ForwardRef as ReactComponent };